import Paper, { paperClasses, PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography, {
  typographyClasses,
  TypographyProps,
} from '@mui/material/Typography';

export const FOOTER_HEIGHT = 40;

export const StyledContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(2),
  width: '100%',
}));

export const StyledPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  [`&.${paperClasses.root}`]: {
    padding: theme.spacing(4),
  },
}));

export const StyledTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      display: 'block',
      marginTop: theme.spacing(2),
    },
  }),
);
